var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon3",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "premium-icon-damage-465106",
    transform: "translate(488.022 758.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33774",
    "data-name": "\\uD328\\uC2A4 33774",
    d: "M33.2,305.533H.756a.756.756,0,0,0-.756.756v.195a.756.756,0,0,0,.756.756H33.2a.756.756,0,0,0,.756-.756v-.195A.756.756,0,0,0,33.2,305.533Z",
    transform: "translate(0 -157.252)",
    fill: "#a9adbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33775",
    "data-name": "\\uD328\\uC2A4 33775",
    d: "M33.2,312.406H.756a.755.755,0,0,1-.68-.427.751.751,0,0,0-.076.328v.195a.756.756,0,0,0,.756.756H33.2a.756.756,0,0,0,.756-.756,1.033,1.033,0,0,0-.076-.523A.755.755,0,0,1,33.2,312.406Z",
    transform: "translate(0 -163.27)",
    fill: "#8c93aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33776",
    "data-name": "\\uD328\\uC2A4 33776",
    d: "M311.849,305.533H298.443a11.088,11.088,0,0,0,1.334,1.707h12.072a.756.756,0,0,0,.756-.756v-.195A.756.756,0,0,0,311.849,305.533Z",
    transform: "translate(-278.651 -157.252)",
    fill: "#b8bccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33777",
    "data-name": "\\uD328\\uC2A4 33777",
    d: "M321,311.98h0a.755.755,0,0,1-.68.427h-12.8a11.068,11.068,0,0,0,.732.852h12.072a.756.756,0,0,0,.756-.756A1.048,1.048,0,0,0,321,311.98Z",
    transform: "translate(-287.118 -163.271)",
    fill: "#a2a8ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33778",
    "data-name": "\\uD328\\uC2A4 33778",
    d: "M45.01,157.246a.512.512,0,0,1-.512-.512v-2.966a.512.512,0,0,1,1.024,0v2.966A.512.512,0,0,1,45.01,157.246Z",
    transform: "translate(-41.547 -15.073)",
    fill: "#a9adbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33779",
    "data-name": "\\uD328\\uC2A4 33779",
    d: "M39.752,141.5l4.673,2.9h2.683l.126-.109-6.651-4.133a.787.787,0,0,0-.831,1.338Z",
    transform: "translate(-36.768 -2.734)",
    fill: "#f98506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33780",
    "data-name": "\\uD328\\uC2A4 33780",
    d: "M40.729,141.223a1.092,1.092,0,0,1-.488-1.172.788.788,0,0,0-.489,1.452l4.673,2.9h1.428Z",
    transform: "translate(-36.769 -2.741)",
    fill: "#f26606"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9",
    "data-name": "\\uD0C0\\uC6D0 9",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(3.463 145.39)",
    fill: "#777984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33781",
    "data-name": "\\uD328\\uC2A4 33781",
    d: "M53.676,265.664a3.746,3.746,0,0,1,3.016-3.673,3.745,3.745,0,1,0,0,7.347A3.746,3.746,0,0,1,53.676,265.664Z",
    transform: "translate(-48.754 -116.529)",
    fill: "#61626d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_10",
    "data-name": "\\uD0C0\\uC6D0 10",
    cx: 2.286,
    cy: 2.286,
    r: 2.286,
    transform: "translate(4.922 146.848)",
    fill: "#c8cbd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33782",
    "data-name": "\\uD328\\uC2A4 33782",
    d: "M77.217,284.018a2.286,2.286,0,1,0,0,4.342A2.289,2.289,0,0,1,77.217,284.018Z",
    transform: "translate(-69.292 -137.054)",
    fill: "#a9adbf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_11",
    "data-name": "\\uD0C0\\uC6D0 11",
    cx: 0.853,
    cy: 0.853,
    r: 0.853,
    transform: "translate(6.355 148.281)",
    fill: "#777984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33783",
    "data-name": "\\uD328\\uC2A4 33783",
    d: "M97.187,305.7a.853.853,0,1,0,0,1.364A.851.851,0,0,1,97.187,305.7Z",
    transform: "translate(-89.467 -157.242)",
    fill: "#61626d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33784",
    "data-name": "\\uD328\\uC2A4 33784",
    d: "M43.385,144.591a2.993,2.993,0,0,0-2.993-2.993h-.306l-2.754-3.462a2.848,2.848,0,0,0-2.2-1.024H27.206a3.868,3.868,0,0,0-2.384.795l-4.3,3.691H13.9a2.993,2.993,0,0,0-2.993,2.993v3.692c.067,0-.3,0,2.838,0h0a3.745,3.745,0,0,1,7.293,0H33.37a3.745,3.745,0,0,1,7.293,0h2.721v-3.691Z",
    transform: "translate(-10.186 0)",
    fill: "#ff8c01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33785",
    "data-name": "\\uD328\\uC2A4 33785",
    d: "M12.616,207.745a2.993,2.993,0,0,1,2.993-2.993H13.9a2.993,2.993,0,0,0-2.993,2.993v3.692c.067,0-.221,0,1.706,0v-3.691Z",
    transform: "translate(-10.186 -63.154)",
    fill: "#f45c0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33786",
    "data-name": "\\uD328\\uC2A4 33786",
    d: "M284.744,141.6h-.306l-2.754-3.462a2.848,2.848,0,0,0-2.2-1.024h-5.533a11.041,11.041,0,0,0,.378,11.169h3.46a3.679,3.679,0,0,1,7.156,0h2.79v-3.691A2.993,2.993,0,0,0,284.744,141.6Z",
    transform: "translate(-254.539 0)",
    fill: "#fca51a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33787",
    "data-name": "\\uD328\\uC2A4 33787",
    d: "M10.819,230.469a1.82,1.82,0,0,0,2.26-1.57,1.753,1.753,0,0,0-1.858-1.6C10.729,228.145,10.819,228.714,10.819,230.469Z",
    transform: "translate(-10.095 -84.202)",
    fill: "#6ea5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33788",
    "data-name": "\\uD328\\uC2A4 33788",
    d: "M12.5,230.037a6.477,6.477,0,0,1,.138-2.144,2,2,0,0,0-1.442-.6c-.5.971-.4,1.256-.4,3.174A2.093,2.093,0,0,0,12.5,230.037Z",
    transform: "translate(-10.073 -84.203)",
    fill: "#4e8dd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33789",
    "data-name": "\\uD328\\uC2A4 33789",
    d: "M211.712,162.712l-1.448-1.82a2.471,2.471,0,0,0-1.828-.869h-6.771a3.3,3.3,0,0,0-2.03.679l-2.285,1.964a.342.342,0,0,0,.222.6h13.872a.341.341,0,0,0,.267-.554Z",
    transform: "translate(-184.151 -21.391)",
    fill: "#6ea5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33790",
    "data-name": "\\uD328\\uC2A4 33790",
    d: "M233.242,160.023a3.252,3.252,0,0,0-2.191.818v2.425h6.381v-3.243Z",
    transform: "translate(-215.727 -21.392)",
    fill: "#93c1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33791",
    "data-name": "\\uD328\\uC2A4 33791",
    d: "M272.81,163.266h3.611v-3.243H273.45A10.993,10.993,0,0,0,272.81,163.266Z",
    transform: "translate(-254.718 -21.392)",
    fill: "#afd4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33792",
    "data-name": "\\uD328\\uC2A4 33792",
    d: "M291.131,229.144h-1.47a.512.512,0,0,1,0-1.024h1.47a.512.512,0,0,1,0,1.024Z",
    transform: "translate(-269.973 -84.973)",
    fill: "#464856"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_12",
    "data-name": "\\uD0C0\\uC6D0 12",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(23.06 145.39)",
    fill: "#777984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33793",
    "data-name": "\\uD328\\uC2A4 33793",
    d: "M349.172,265.664a3.746,3.746,0,0,1,3.016-3.673,3.745,3.745,0,1,0,0,7.347A3.746,3.746,0,0,1,349.172,265.664Z",
    transform: "translate(-324.653 -116.529)",
    fill: "#61626d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_13",
    "data-name": "\\uD0C0\\uC6D0 13",
    cx: 2.286,
    cy: 2.286,
    r: 2.286,
    transform: "translate(24.519 146.848)",
    fill: "#c8cbd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33794",
    "data-name": "\\uD328\\uC2A4 33794",
    d: "M372.713,284.018a2.286,2.286,0,1,0,0,4.342A2.289,2.289,0,0,1,372.713,284.018Z",
    transform: "translate(-345.191 -137.055)",
    fill: "#a9adbf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_14",
    "data-name": "\\uD0C0\\uC6D0 14",
    cx: 0.853,
    cy: 0.853,
    r: 0.853,
    transform: "translate(25.952 148.281)",
    fill: "#777984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33795",
    "data-name": "\\uD328\\uC2A4 33795",
    d: "M392.684,305.695a.853.853,0,1,0,0,1.364A.851.851,0,0,1,392.684,305.695Z",
    transform: "translate(-365.367 -157.242)",
    fill: "#61626d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon3);
export default __webpack_public_path__ + "static/media/sec2Icon3.b7effb497234017a8d87bc1092c91e45.svg";
export { ForwardRef as ReactComponent };